import topic from '../topic';
export const optnAPI = {
  getAllOptns: topic.optnTopic + '/get_all_optns',
  getAllContent: topic.optnTopic + '/get_all_content',
  getAllOptAction: topic.optnTopic + '/get_all_opt_action',
  getOptnByPermId: topic.optnTopic + '/get_optn_by_perm_id',
  editContent: topic.optnTopic + '/edit_content'
};
